<template>
  <div id="Road">
    <div class="head">
      <div class="left">
        <span>连续出现</span>
        <Input @on-change="markContinuous" v-model="count" placeholder style="width: 60px" />
        <span>次以上</span>
        <Select v-model="select" style="width:60px">
          <Option :value="dataKeyName(key)[0]">{{dataKeyName(key)[0]}}</Option>
          <Option :value="dataKeyName(key)[1]">{{dataKeyName(key)[1]}}</Option>
          <Option v-if="betType!='ks'" :value="dataKeyName(key)[2]">{{dataKeyName(key)[2]}}</Option>
        </Select>
        <Button type="primary" style="margin:0 5px" @click="markContinuous">确认</Button>
        <span>出现的次数为：{{selectRes}}</span>
      </div>
      <div class="right">
        <span>{{date}}累计:</span>
        <span>{{dataKeyName(key)[0]}}({{statisRoad[0]}})</span>
        <span>{{dataKeyName(key)[1]}}({{statisRoad[1]}})</span>
        <span class="red">总和 {{dataKeyName(key).join('')}}</span>
        <span class="red">最新</span>
        <span class="tobottom"></span>
      </div>
    </div>
    <div class="con">
      <ul ref="lists">
        <li
          v-for="(it,i) in data[key]"
          :class="[`color${i % 2}`,{'mark':mark === it.key && it.value >= count}]"
          :key="i"
        >
          <p v-for="(is,j) in it.value" :key="j">{{formatKey(it.key)}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Road",

  props: {
    data: {
      type: [Array, Object],
      default() {
        return [];
      }
    },
    date: {
      type: String,
      default: "今天"
    }
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    },
    reverseData() {
      // return this.data.data.arrs.reverse();
    },
    statisRoad() {
      var arr = [];
      var resuilt = [0, 0];
      var d = this.data[this.key];
      for (let i = 0; i < d.length; i++) {
        const e = d[i];
        if (!arr.includes(e.key)) {
          arr.push(e.key);
        }
      }
      for (let i = 0; i < d.length; i++) {
        const e = d[i];
        arr.map((v, i) => {
          if (e.key == v) {
            resuilt[i] += e.value;
          }
        });
      }

      return resuilt;
    }
  },
  data() {
    return {
      count: 1,
      select: "",
      selectRes: 0,
      key: "",
      mark: ""
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // console.log("adad", this.data);
      this.key = Object.keys(this.data)[0];
      this.select = this.dataKeyName(this.key)[0];
    },
    dataKeyName(key) {
      return {
        bigSmall: ["大", "小"],
        singleDouble: ["单", "双"]
      }[key];
    },
    formatKey(key) {
      return {
        big: "大",
        small: "小",
        single: "单",
        double: "双",
        he: "和",
        all: "通吃"
      }[key];
    },
    formatValue(key) {
      return {
        大: "big",
        小: "small",
        单: "single",
        双: "double",
        和: "he",
        通吃: "all"
      }[key];
    },
    markContinuous() {
      this.mark = this.formatValue(this.select);
      // console.log(this.mark, this.select);
      this.$nextTick(() => {
        let len = this.$refs.lists.getElementsByClassName("mark").length;
        this.selectRes = len;
      });
    }
  }
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 1200px) {
  #Road {
    width: 100% !important;
  }
}
#Road {
  width: 1140px;
  margin: 0 auto;
  margin-bottom: 20px;
  .head {
    border: 1px solid #e6e6e6;
    background-color: #f5f5f5;
    height: 43px;
    font-size: 14px;
    color: #555;
    min-width: 1080px;
    span {
      margin: 0 5px;
    }
    .left {
      float: left;
      display: flex;
      align-items: center;
      height: 100%;
      padding-left: 10px;
    }
    .right {
      height: 100%;
      float: right;
      display: flex;
      align-items: center;

      .red {
        color: rgb(241, 2, 11);
      }
      .tobottom {
        width: 20px;
        height: 38px;
        padding: 0;
        background: url("../../../assets/img/bjpknum.png") no-repeat -257px -235px;
      }
    }
  }
  .con {
    min-width: 1080px;
    min-height: 130px;
    border: 1px solid #e6e6e6;
    border-top: 0;
    background: url("../../../assets/img/table_bg.png") repeat;
    ul {
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: flex-end;
      overflow-x: auto;
    }
    li {
      flex: none;
      min-height: 130px;
      width: 30px;
      flex-shrink: 0;
      text-align: center;
      font-weight: normal;

      &:nth-last-child(2n) {
        background-color: #fff;
      }
      &:nth-last-child(2n-1) {
        background-color: #f5f5f5;
      }

      &:nth-last-child(1) p:nth-last-child(1) {
        font-weight: bold;
      }
      &.mark {
        background-color: rgb(253, 173, 86);
        color: #fff;
      }
      &.color1 {
        color: rgb(241, 2, 11);
        &.mark {
          color: rgb(241, 2, 11);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Zongheluzhu/Road.vue